import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';

import { PrimarySubscriptionPlanAccessAliasEnum } from '../../enums/monetization';
import { GenericComponent } from '../../misc/components/generic/generic.component';
import { MonetizationService } from '../../misc/services/monetization.service';
import * as fromSettingActions from '../../store/actions/setting.actions';
import * as fromOrganizationSelectors from '../../store/selectors/organization.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-change-icon',
  standalone: false,
  templateUrl: './change-icon.page.html'
})
export class ChangeIconPageComponent extends GenericComponent {
  private activatedRoute = inject(ActivatedRoute);
  private alertController = inject(AlertController);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private monetizationService = inject(MonetizationService);
  private router = inject(Router);
  private store = inject(Store);

  isOnboardingFlow = true;
  alternateAppIconPreviewUrl: string | null = '';
  applicationName: string | null = '';

  constructor() {
    super();
    this.isOnboardingFlow = !!this.activatedRoute.snapshot.data['isOnboardingFlow'];
    this.addUniqueSubscription(
      'selectAlternateAppIconPreviewUrl',
      this.store
        .pipe(select(fromOrganizationSelectors.selectAlternateAppIconPreviewUrl))
        .subscribe((alternateAppIconPreviewUrl) => {
          this.alternateAppIconPreviewUrl = alternateAppIconPreviewUrl;
        })
    );
    this.addUniqueSubscription(
      'selectApplicationName',
      this.store.pipe(select(fromOrganizationSelectors.selectApplicationName)).subscribe((applicationName) => {
        this.applicationName = applicationName;
      })
    );
  }

  async navigateHome() {
    const hasAccess = await this.monetizationService.accessFeature([PrimarySubscriptionPlanAccessAliasEnum.A], {
      preventPaywall: true
    });
    if (!hasAccess) {
      const modal = await this.monetizationService.showPrimarySubscriptionPlanPaywall({ onboardingPaywall: true });
      await modal.onDidDismiss();
    }
    await this.router.navigate(['/']);
  }

  async onSubmit(useDefault: boolean) {
    if (!useDefault) {
      this.store.dispatch(fromSettingActions.updateApplicationIcon({ payload: { useDefault: false } }));
      await this.navigateHome();
    } else {
      const alert = await this.alertController.create({
        backdropDismiss: false,
        buttons: [
          {
            handler: async () => await this.navigateHome(),
            text: 'Ok'
          }
        ],
        header: 'Message',
        message: 'You can change the application icon from the settings screen.'
      });

      await alert.present();
      this.changeDetectorRef.detectChanges();
    }
  }
}
